import NBType, { InferType } from '@netbase/nb-type'
import MetricCategoryItem from '../enums/MetricCategoryItem'
import ReturnStatus from '../enums/ReturnStatus'

const MetricSeriesSchema = NBType.object().shape('MetricSeriesSchema', {
  /* @prop */
  categoryItem: NBType.enum(MetricCategoryItem).nullable(),
  /* @prop */
  seriesName: NBType.string(), // TODO: not sure why NBType.enum(MetricSeries) will cause CB-32613,
  /* @prop */
  set: NBType.array().of(NBType.number()),
  /* @prop */
  status: NBType.enum(ReturnStatus).nullable()
  /* END */
})
export default MetricSeriesSchema
export type MetricSeries = InferType<typeof MetricSeriesSchema>
// RESERVE BELOW
